'use strict';

module.exports = {
    CONFIRMATION_BLOCK: '.js-confirmation-block',
    CONFIRMATION_JSON: '#js-json-data',
    REGISTRATION_FORM: '.js-registration-form',
    UPGRADE_FORM: '.js-upgrade-form',
    EXTEND_FORM: '.js-extend-form',
    OFFLINE_FORM: '.js-offline-form',
    SUBMIT_UPGRADE_FORM: '.js-submit-upgrade-form',
    SUBMIT_TRADE_FORM: '.js-submit-trade-form',
    NEXT_BT: '.js-next',

    STEPPER_PROGRESS: '.js-stepper__progress-bar',
    STEPPER_TAB: '.js-stepper__tab',
    STEPPER_TABS: '.js-stepper__tabs',
    STEPPER_NAV: '.js-stepper__nav',
    STEPPER_LIST: '.js-stepper__tabs-list',
    STEPPER_STEP_ACIVE: '.stepper__step_active',

    STEPPER_SHOW_OPTION: '.js-registration-option',

    CUSTOMER_TYPE: '.js-customer_type',
    CUSTOMER_TYPE_VALUE: '.js-customer_type_value',
    PROF_TYPE: '.js-prof_type',
    OTHER_PROFESSION: '.js-other_profession',
    STADY_TYPE: '.js-studying',
    OTHER_STADY: '.js-other_stady',
    TITLE: '.js-title',
    FIRST_NAME: '.js-firstname',
    LAST_NAME: '.js-lastname',
    PHONE: '.js-phone',
    CLASS_TRADE_PHONE: '.js-phone_tradecard',

    MANDATORY_CHECKBOXES_GROUP: '.js-mandatory-checkbox-group',
    MANDATORY_CHECKBOXES: '.js-mandatory-checkbox',

    BARBER_ACTIVATOR_BUTTON: '.js-barber-questions-bt',
    BARBER_GO_BACK_BUTTON: '.js-barber-questions-back',
    BARBER_QUESTIONS_EL: '.js-barber-questions',
    BARBER_QUESTIONS_CHECK: '.js-check_barber_questions',

    UPLOADER: '.js-uploader',
    UPLOADER_LABEL: '.js-uploader-label',

    UPLOADER_SUCCESS: '.js-uploader-success',
    UPLOADER_FAIL: '.js-uploader-fail',
    UPLOADER_ANOTHER: '.js-uploader-another',
    UPLOADER_ANOTHER_BT: '.js-uploader-another-bt',
    UPLOADER_ANOTHER_ERROR: '.js-uploader-another-error',
    UPLOADER_INIT: '.js-uploader-init',
    UPLOADER_INPUT: '.js-uploader-input',
    UPLOADER_FILE_LIST: '.js-uploader-filelist',
    UPLOADER_ACTIVE: '.uploader__label_active',
    UPLOADER_FILENAME: '.uploader__filename',
    _UPLOADER_REMOVE: 'js-uploader-remove-file',

    CAMERA: '.js-camera',
    CAMERA_INPUT: '.js-camera-input',
    CAMERA_INIT: '.js-camera-init',
    CAMERA_SUCCESS: '.js-camera-success',
    _CAMERA_ACTIVE: 'camera__label_active',

    ADDRESS_LINE1: '.js-address-line1',
    ADDRESS_LINE2: '.js-address-line2',
    ADDRESS_LINE3: '.js-address-line3',
    ADDRESS_LINE4: '.js-address-line4',

    ADDRESS_MANUAL_LINE1: '.js-addressLine1',
    ADDRESS_MANUAL_LINE2: '.js-addressLine2',
    ADDRESS_MANUAL_LOCALITY: '.js-locality',
    ADDRESS_MANUAL_POSTAL: '.js-postalCode',
    ADDRESS_MANUAL_TITLE: '.js-manual-title',
    ADDRESS_MANUAL_FIRST_NAME: '.js-manual-firstname',
    ADDRESS_MANUAL_LAST_NAME: '.js-manual-lastname',
    ADDRESS_MANUAL_PHONE: '.js-manual-phone',

    ADDRESS_RESULT: '.js-address-result',
    ADDRESS_MANUAL: '.js-address-manual',
    ADDRESS_MANUAL_FIELDS: '.js-manual-fields',
    ADDRESS_SEARCH: '.js-address-search',
    ADDRESS_ADD_ADDRESS: '.js-add_address',
    ADDRESS_CLEAR: '.js-address_clear',
    ADDRESS_SEARCH_INPUT: '.js-address_search_input',
    ID_ADDRESS_FORM_SECTION: '#address-form-section',

    ADDRESS_CANCEL_BT: '.js-add_address_cancel',

    EMAIL: '.js-email_field',
    EMAIL_ERROR: '.js-email_error',

    STORE_ERROR: '.js-store-error',

    CLASS_COURSE_START: '.js-course_start',
    CLASS_COURSE_START_MONTH: '.js-course_start_month',
    CLASS_COURSE_START_YEAR: '.js-course_start_year',

    CLASS_COURSE_END: '.js-course_end',
    CLASS_COURSE_END_MONTH: '.js-course_end_month',
    CLASS_COURSE_END_YEAR: '.js-course_end_year',

    CLASS_BIRTHDAY: '.js-birthday',
    CLASS_BIRTHDAY_DAY: '.js-birthday_day',
    CLASS_BIRTHDAY_MONTH : '.js-birthday_month',
    CLASS_BIRTHDAY_YEAR: '.js-birthday_year',

    ROLE_SELECTOR: '.js-role-selector',
    ROLE_ADDITIONAL: '.js-role-additional',
    ROLE_SALON_OWNER: '.js-role-salon-owner',
    ROLE_MOBILE_HAIRDRESSER: '.js-role-mobile-hairdresser',

    CLASS_HIDE_COMPANY_NAME: '.js-hide-company-name',
    CLASS_COMPANYOWNER_CHECK: '.js-check_company_owner',
    CLASS_COMPANY_NAME: '.js-company_name',
    CLASS_SIRET_NUMBER: '.js-siretnumber',
    CLASS_KVK_NUMBER: '.js-kvknumber',
    CLASS_VAT_NUMBER: '.js-vatnumber',
    CLASS_ENTERPRISE_NUMBER: '.js-enterprisenumber',
    CLASS_REG_OPTION_SECTION: '.js-registration-option-section',

    CONSTANTS: {
        PROFESSIONAL: 'professional',
        STUDENT: 'student',
        BARBER: 'barber',
        ROLES: {
            OTHER: 'other',
            SALON_OWNER: 'salon-owner',
            SALON_STAFF: 'salon-employee',
            MOBILE_HAIR: 'mobile-hairdresser',
            MOBILE_TECH: 'home-beauty'
        },
        PROFESSION_TYPE: {
            PROFESSIONAL: 'hair_beauty',
            STUDENT: 'student',
            BARBER: 'barber'
        },
        STAGE_VIEW: 'stage_view',
        COMPLETE_STAGE: 'complete_stage',
        STAGE_EVENT_STEPS: {
            2: 'my_details',
            3: 'my_account'
        },
        POSSIBLE_STEPS_IN_URL: [2,3,4,5]
    }
};
